<h1 mat-dialog-title>Validation Note(s) - {{inputId}}</h1>

<div mat-dialog-content class="wordbreak">
  <div [innerHTML]="inputText | replaceText"></div>
</div>

<div mat-dialog-actions [align]="'end'">
  <button mat-button (click)="onCloseClick()" id="validationNoteDialogClose">Close</button>
</div>
